import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class FinanceCategoriesApi extends ApiModule {
  constructor() {
    super(ModulesMap.FINANCE_CATEGORIES, {
      entity: 'finance_categories',
    })
  }
}
